import { Navigate, useLocation } from "react-router-dom";

type RequireStateProps = {
  children: React.ReactNode;
  redirectTo: string;
  requiredKey?: string;
};

export default function RequireState({
  children,
  redirectTo,
  requiredKey,
}: RequireStateProps) {
  const location = useLocation();

  const hasState = requiredKey
    ? Boolean(location.state?.[requiredKey])
    : Boolean(location.state);

  if (!hasState) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}